/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

/*eslint complexity: 0*/

// TODO: refactor conditionals in this module

import * as consts from '../../../const.js';
import { generateIteratorKey as keygen } from '../../../utils/helpers';
import { Button, Dropdown, DropdownButton, MenuItem } from 'react-bootstrap';
import React from 'react';
import { UPLOAD_PDF, WRONG_TYPE_ERROR } from '../../../const';

const columns = {
  documentName: consts.DOCUMENT_NAME,
  consentingStatus: consts.STATUS,
  signed: consts.SIGNED_DOCUMENT_PDF,
  journal: consts.JOURNAL,
  actions: consts.ACTIONS,
  addNote: consts.ADD_NEW_NOTE,
  viewJournal: consts.VIEW_CONSENTING_JOURNAL,
  generatePdf: consts.GENERATE_PDF,
  viewSignedPdf: consts.VIEW_SIGNED_PDF,
  deleteSignedPdf: consts.DELETE_SIGNED_PDF,
  viewPdf: consts.VIEW_PDF,
  changeDocumentStatus: consts.CHANGE_DOCUMENT_STATUS,
  removeParticipantDocument: consts.REMOVE_DOCUMENT_FROM_LIST,
  removeEntireDocument: consts.REMOVE_ENTIRE_DOCUMENT_FROM_LIST,
  viewAddendumPdf: consts.VIEW_ADDENDUM_PDF,
  deleteAddendum: consts.DELETE_ADDENDUM,
  changeAnswers: consts.CHANGE_ANSWERS
};

const ADD_OR_REMOVE_DOCUMENT = 'ADD_OR_REMOVE_DOCUMENT';
const UPDATE_CONSENT_DOCUMENT_STATUS = 'UPDATE_CONSENT_DOCUMENT_STATUS';
const VIEW_AND_DOWNLOAD_SIGNED_CONSENT_DOCUMENT = 'VIEW_AND_DOWNLOAD_SIGNED_CONSENT_DOCUMENT';
const UPLOAD_DELETE_SIGNED_CONSENT = 'UPLOAD_DELETE_SIGNED_CONSENT';
const VIEW_AND_DOWNLOAD_UNSIGNED_CONSENT_DOCUMENT = 'VIEW_AND_DOWNLOAD_UNSIGNED_CONSENT_DOCUMENT';

const hasPermission =
  (permission) =>
  (permissions = []) =>
    permissions.includes(permission);

const delete_options = {
  pdf: 'pdf',
  document: 'doc',
  entireDocument: 'entireDoc'
};

const checkWindowFit = (el, children) => {
  const { bottom } = el.getBoundingClientRect();
  const spaceBelow = window.innerHeight - bottom;
  const dropdownHeight = 5 + 36 * children;

  spaceBelow < dropdownHeight ? el.classList.add('open-on-top') : el.classList.remove('open-on-top');
};

const upload = (e, actions, consenting) => {
  const fileItem = e.currentTarget.files[0];

  if (fileItem.type !== 'application/pdf') actions.showError(WRONG_TYPE_ERROR);
  else {
    let formData = new FormData();

    formData.append('file', fileItem);
    actions.uploadPdf(consenting.consentingGid, consenting, formData);
  }
};

export const generateItem = (consenting, actions, documentName) => {
  if (
    !consenting.signedConsenting &&
    consenting.consentingStatus !== 'ABORTED' &&
    hasPermission(UPLOAD_DELETE_SIGNED_CONSENT)(consenting.permissions)
  ) {
    let fU;
    const fileup = (
      <input
        id="file-input"
        accept=".pdf"
        type="file"
        ref={(fileup) => (fU = fileup)}
        onChange={(e) => upload(e, actions, consenting)}
        className="file-input"
      />
    );

    return [
      <div className="dropdown-menu-separator" />,
      <div className="upload-scanned-copy">
        <div className="file-container">{fileup}</div>
        <i className="material-icons error">error</i>
        <Button id="file-upload-button" bsStyle="link" className="pseudo-menu-button" onClick={() => fU.click()}>
          {UPLOAD_PDF}
        </Button>
      </div>
    ];
  } else {
    if (consenting.consentingStatus === 'SIGNED') {
      return (
        <MenuItem
          eventKey="3"
          id="signed-docs-view-signed-doc"
          {...keygen()}
          disabled={!hasPermission(VIEW_AND_DOWNLOAD_SIGNED_CONSENT_DOCUMENT)(consenting.permissions)}
          onSelect={() => actions.showPdfIframe(consenting.consentGid, consenting.consentingGid, true, documentName)}
        >
          {columns.viewSignedPdf}
        </MenuItem>
      );
    } else if (
      consenting.consentingStatus === 'SIGNED_ON_PAPER' &&
      (hasPermission(VIEW_AND_DOWNLOAD_SIGNED_CONSENT_DOCUMENT)(consenting.permissions) ||
        hasPermission(UPLOAD_DELETE_SIGNED_CONSENT)(consenting.permissions))
    ) {
      return [
        <div className="dropdown-menu-separator" />,
        <div className="pseudo-menu-button">
          <Button
            bsStyle="link"
            className="view-signed-pdf"
            id="signed-docs-view-signed-doc"
            disabled={!hasPermission(VIEW_AND_DOWNLOAD_SIGNED_CONSENT_DOCUMENT)(consenting.permissions)}
            onClick={() => actions.showPdfIframe(consenting.consentGid, consenting.consentingGid, true, documentName)}
          >
            {columns.viewSignedPdf}
          </Button>
        </div>,
        hasPermission(UPLOAD_DELETE_SIGNED_CONSENT)(consenting.permissions) && [
          <div className="pseudo-menu-button">
            <Button
              className="delete-signed-pdf"
              id="delete-signed-pdf"
              onClick={() => actions.deleteDocument(consenting, delete_options.pdf)}
            >
              {columns.deleteSignedPdf}
            </Button>
          </div>,
          <div className="dropdown-menu-separator" />,
          <MenuItem eventKey="99" id="signed-docs-change-answers" onClick={() => actions.changeAnswers(consenting)}>
            {columns.changeAnswers}
          </MenuItem>
        ]
      ];
    }
  }
};

export const generateActions = (consenting, actions, user, documentName, participant) => {
  if (participant) consenting.studyGid = participant.studyGid;
  const canUpdateConsentStatus = hasPermission(UPDATE_CONSENT_DOCUMENT_STATUS)(consenting.permissions);
  const menuItemsCount = 3 + (canUpdateConsentStatus ? 1 : 0);
  const dropdownButtonId = `dropdown-button-${consenting.consentGid}`;

  return (
    <div>
      {!consenting.signedConsenting && consenting.consentingStatus !== 'ABORTED' ? (
        <i className="material-icons error outer">error</i>
      ) : (
        ''
      )}
      <DropdownButton
        bsStyle="link"
        className="action-link"
        title={consts.ACTIONS}
        id={dropdownButtonId}
        onClick={() => {
          event.stopPropagation();
          checkWindowFit(document.getElementById(dropdownButtonId), menuItemsCount);
        }}
      >
        <MenuItem
          eventKey="1"
          {...keygen()}
          id="signed-docs-add-note"
          onClick={() => actions.createNewNote(consenting.consentGid, consenting.consentingGid, user)}
        >
          {columns.addNote}
        </MenuItem>

        <MenuItem
          eventKey="2"
          {...keygen()}
          id="signed-docs-view-journal"
          onClick={() => actions.showJournal(consenting.consentGid, consenting.consentingGid)}
        >
          {columns.viewJournal}
        </MenuItem>
        {canUpdateConsentStatus && buildChangeStatusMenuItem('signed', actions, consenting, participant)}
        {generateItem(consenting, actions, documentName)}
      </DropdownButton>
    </div>
  );
};

export const generateAddendumActions = (addendum, actions, documentName) => {
  const menuItemsCount = 2;
  const dropdownButtonId = `dropdown-button-${addendum.id}`;
  const addendumId = addendum.id;
  return (
    <div>
      <DropdownButton
        bsStyle="link"
        className="action-link"
        title={consts.ACTIONS}
        id={dropdownButtonId}
        onClick={() => {
          event.stopPropagation();
          checkWindowFit(document.getElementById(dropdownButtonId), menuItemsCount);
        }}
      >
        <MenuItem
          eventKey="1"
          {...keygen()}
          className="addendum-action-button view-signed-pdf"
          disabled={!hasPermission(VIEW_AND_DOWNLOAD_SIGNED_CONSENT_DOCUMENT)(addendum.permissions)}
          onSelect={() =>
            actions.showPdfIframe(addendum.consentGid, addendum.consentingGid, true, documentName, addendumId)
          }
        >
          {columns.viewAddendumPdf}
        </MenuItem>

        {addendum.consentingStatus === 'SIGNED_ON_PAPER' && (
          <MenuItem
            eventKey="2"
            {...keygen()}
            className="addendum-action-button delete-signed-pdf"
            onClick={() => {
              actions.deleteAddendum(addendum);
            }}
          >
            {columns.deleteAddendum}
          </MenuItem>
        )}
      </DropdownButton>
    </div>
  );
};

function buildChangeStatusMenuItem(classification, actions, consenting, participant) {
  let component = (
    <MenuItem
      eventKey="3"
      {...keygen()}
      id={`${classification}-docs-change-doc-status`}
      onClick={() =>
        actions.editDocumentStatus(
          consenting.consentGid,
          consenting.consentingGid,
          consenting.consentName,
          consenting.consentingStatus,
          consenting.documentVersion,
          consenting.signedTimestamp
        )
      }
    >
      {columns.changeDocumentStatus}
    </MenuItem>
  );

  if (['STUDY_COMPLETED', 'STUDY_TERMINATED'].includes(participant.overallStatus)) {
    component = <span />;
  }

  let isWithdrawnConsent =
    participant.overallStatus === 'WITHDRAWN_CONSENT' && consenting.consentingStatus === 'WITHDRAWN_CONSENT';

  if (isWithdrawnConsent) {
    component = (
      <MenuItem
        eventKey="3"
        {...keygen()}
        id={`${classification}-docs-change-doc-status`}
        onClick={() =>
          actions.editDocumentStatus(
            consenting.consentGid,
            consenting.consentingGid,
            consenting.consentName,
            consenting.consentingStatus,
            consenting.documentVersion,
            consenting.signedTimestamp
          )
        }
      >
        {columns.changeDocumentStatus}
      </MenuItem>
    );
  }

  if (!consenting.latestVersion && !isWithdrawnConsent) {
    component = <span />;
  }
  return component;
}

export const createActions = (
  row,
  actions,
  documentName,
  classification,
  user,
  participant,
  participantDocumentActionsAllowed
) =>
  row.consentingGid
    ? createActionsForDocumentWithConsenting(
        row,
        actions,
        documentName,
        classification,
        user,
        participant,
        participantDocumentActionsAllowed
      )
    : createActionsForDocumentWithNoConsenting(
        row,
        actions,
        documentName,
        classification,
        user,
        participant,
        participantDocumentActionsAllowed
      );

function createActionsForDocumentWithConsenting(
  row,
  actions,
  documentName,
  classification,
  user,
  participant,
  participantDocumentActionsAllowed
) {
  let items = [],
    children = 0;
  let changeDocumentStatusHidden =
    participant &&
    (participant.studyStatus ||
      row.consentingStatus === 'SUPERSEDED' ||
      row.consentingStatus === 'REMOVED' ||
      'WITHDRAWN_CONSENT' === participant.consentingStatus);
  let changeDocumentStatusOption = null,
    removeEntireDocOption = null;

  if (changeDocumentStatusHidden === false && hasPermission(UPDATE_CONSENT_DOCUMENT_STATUS)(row.permissions)) {
    changeDocumentStatusOption = buildChangeStatusMenuItem(classification, actions, row, participant);
    children++;
  }
  let removeDocumentAllowed =
    participantDocumentActionsAllowed &&
    row.documentConfiguration.individuallyAssignable &&
    ((row.consentingStatus === 'ABORTED' && !row.documentConfiguration.mandatorySign) || classification === 'assigned');
  if (removeDocumentAllowed && hasPermission(ADD_OR_REMOVE_DOCUMENT)(row.permissions)) {
    removeEntireDocOption = buildRemoveEntireDocMenuItem(row, actions, classification);
    children++;
  }

  items.push(
    <MenuItem
      eventKey="1"
      {...keygen()}
      id={`${classification}-docs-add-note`}
      onClick={() => actions.createNewNote(row.consentGid, row.consentingGid, user)}
    >
      {columns.addNote}
    </MenuItem>,
    <MenuItem
      eventKey="2"
      {...keygen()}
      id={`${classification}-docs-view-journal`}
      onClick={() => actions.showJournal(row.consentGid, row.consentingGid)}
    >
      {columns.viewJournal}
    </MenuItem>,
    changeDocumentStatusOption && changeDocumentStatusOption,
    removeEntireDocOption && removeEntireDocOption,
    hasPermission(VIEW_AND_DOWNLOAD_UNSIGNED_CONSENT_DOCUMENT)(row.permissions) && (
      <MenuItem
        eventKey="4"
        {...keygen()}
        id={`${classification}-docs-view-print-doc`}
        onClick={() => actions.showPdfIframe(row.consentGid, row.consentingGid, false, documentName)}
      >
        {columns.viewPdf}
      </MenuItem>
    ),
    row.brokenConsenting && hasPermission(VIEW_AND_DOWNLOAD_SIGNED_CONSENT_DOCUMENT)(row.permissions) && (
      <MenuItem
        eventKey="5"
        {...keygen()}
        id={`${classification}-docs-generate-pdf`}
        onClick={() => actions.generatePdf(row.consentingGid, row.studyGid, row.userId)}
      >
        {columns.generatePdf}
      </MenuItem>
    )
  );
  children += 3;

  return createActionsDropDownButton(items, children, documentName, row.consentGid);
}

function createActionsForDocumentWithNoConsenting(
  row,
  actions,
  documentName,
  classification,
  user,
  participant,
  participantDocumentActionsAllowed
) {
  let items = [],
    children = 0;
  if (hasPermission(VIEW_AND_DOWNLOAD_UNSIGNED_CONSENT_DOCUMENT)(row.permissions)) {
    items.push(
      <MenuItem
        eventKey="1"
        {...keygen()}
        id={`${classification}-docs-view-print-doc`}
        onClick={() => actions.showPdfIframe(row.consentGid, row.consentingGid, false, documentName)}
      >
        {columns.viewPdf}
      </MenuItem>
    );
    children++;
  }
  if (
    classification === 'assigned' &&
    participantDocumentActionsAllowed &&
    hasPermission(ADD_OR_REMOVE_DOCUMENT)(row.permissions)
  ) {
    items.push(buildRemoveDocVersionMenuItem(row, actions, classification));
    children++;
    if (row.documentConfiguration.individuallyAssignable) {
      items.push(buildRemoveEntireDocMenuItem(row, actions, classification));
      children++;
    }
  }
  return createActionsDropDownButton(items, children, documentName, row.consentGid);
}

function buildRemoveDocVersionMenuItem(row, actions, classification) {
  return (
    <MenuItem
      eventKey="2"
      {...keygen()}
      id={`${classification}-remove-participant-document`}
      onClick={() => actions.deleteDocument(row, delete_options.document)}
    >
      {columns.removeParticipantDocument}
    </MenuItem>
  );
}

function buildRemoveEntireDocMenuItem(row, actions, classification) {
  return (
    <MenuItem
      eventKey="2"
      {...keygen()}
      id={`${classification}-remove-participant-entire-document`}
      onClick={() => actions.deleteDocument(row, delete_options.entireDocument)}
    >
      {columns.removeEntireDocument}
    </MenuItem>
  );
}

function createActionsDropDownButton(items, children, documentName, consentGid) {
  const dropdownButtonId = `dropdown-button-${consentGid}`;

  return !items.length ? null : (
    <DropdownButton
      bsStyle="link"
      className="action-link"
      title={consts.ACTIONS}
      id={dropdownButtonId}
      onClick={() => {
        event.stopPropagation();
        checkWindowFit(document.getElementById(dropdownButtonId), children);
      }}
    >
      {items}
    </DropdownButton>
  );
}
